import type { FormikValues } from 'formik';
import type { FormFieldName } from '../../../types';
import type { BuildCreatePayloadParams, CreatePayload } from './types';

// Carries every changed, valid field so a create retried after a failure keeps the earlier ones.
export async function buildCreatePayload<TValues extends FormikValues, TPayload extends object>({
  base,
  name,
  values,
  savedValues,
  validationSchema,
  toFieldPayload,
}: BuildCreatePayloadParams<TValues, TPayload>): Promise<CreatePayload<TValues, TPayload>> {
  let data = { ...base };
  const names: Array<FormFieldName<TValues>> = [name];
  for (const otherName in values) {
    if (otherName === name || JSON.stringify(toFieldPayload(otherName, values)) === JSON.stringify(toFieldPayload(otherName, savedValues))) {
      continue;
    }
    try {
      await validationSchema.validateAt(otherName, values);
    } catch {
      continue;
    }
    data = { ...data, ...toFieldPayload(otherName, values) };
    names.push(otherName);
  }
  return { data, names };
}
